import dynamic from 'next/dynamic';
import HariPerkiraanLahir from 'src/containers/HariPerkiraanLahir';
const HeadC = dynamic(() => import('src/components/Head'));
const LoginPage = () => {
  return <>
			<HeadC title="Kalkulator Kehamilan untuk Cek Hari Perkiraan Lahir" description={'Ingin tahu kapan Si Kecil lahir? Gunakan kalkulator HPL Hallobumil untuk cek ' + 'hari perkiraan lahir berdasarkan tanggal haid terakhir Mama, ' + 'demi persiapan yang lebih baik.'} />
			<HariPerkiraanLahir />
		</>;
};
export default LoginPage;